import makeFAIcon from "utils/makeFAIcon";

import { faShoppingCart, faLaptop, faLock, faStore } from "@fortawesome/free-solid-svg-icons";

export const ShoppingCartIcon = makeFAIcon(faShoppingCart);
export const LaptopIcon = makeFAIcon(faLaptop);
export const LockIcon = makeFAIcon(faLock);
export const StoreIcon = makeFAIcon(faStore);
